module.exports = __webpack_public_path__ + "static/media/saunatimeFacebook-1200x630.e62a59a0.jpg";